import {
  QuizPluginMetadataWire,
  QuizQuestionUI,
  QuizUIState
} from 'app/components/management/common/plugins/quiz/types';

export const createEmptyQuizUI = (): QuizUIState => ({
  targetURL: '',
  questions: []
});

export const metadataToUI = (metadata?: QuizPluginMetadataWire | null): QuizUIState => {
  if (!metadata) return createEmptyQuizUI();

  const correctAnswers = metadata.privateData?.correctAnswers || {};
  const pages = metadata.formSettings?.pages || [];

  const questions: QuizQuestionUI[] = [];
  pages.forEach((page) => {
    page.elements.forEach((el) => {
      if (el.type !== 'radiogroup') return;
      const key = el.name;
      questions.push({
        key,
        title: el.title,
        answers: el.choices || [],
        correctAnswer: correctAnswers[key] || ''
      });
    });
  });

  return {
    targetURL: metadata.targetURL || '',
    questions
  };
};

export const uiToMetadata = (ui: QuizUIState): QuizPluginMetadataWire => {
  const correctAnswers: Record<string, string> = {};
  const pages = ui.questions
    .map((q, idx) => {
      if (!q.key) return null;
      if (q.correctAnswer) {
        correctAnswers[q.key] = q.correctAnswer;
      }
      return {
        name: `page_${idx + 1}`,
        elements: [
          {
            name: q.key,
            type: 'radiogroup' as const,
            title: q.title,
            choices: q.answers.filter(Boolean),
            isRequired: true,
            choicesOrder: 'random' as const
          }
        ]
      };
    })
    .filter(Boolean) as QuizPluginMetadataWire['formSettings']['pages'];

  return {
    targetURL: ui.targetURL,
    privateData: {
      correctAnswers
    },
    formSettings: {
      title: 'Pass the Quiz',
      description: `Answer ${pages.length} questions to get rewards.`,
      completedHtml: '',
      showProgressBar: 'bottom',
      firstPageIsStarted: false,
      pages
    }
  };
};
